import { createEntityAdapter, createSlice, EntityState } from '@reduxjs/toolkit';

export interface User {
    uri: string;
    title: string;
    type: 'user';
}
export type UsersRootState = {
    entities: {
        users: EntityState<User>;
    };
};

export const userAdapter = createEntityAdapter<User>({
    selectId: (user) => user.uri,
    sortComparer: (a, b) => a.title.localeCompare(b.title),
});

export const userSlice = createSlice({
    name: 'users',
    initialState: userAdapter.getInitialState(),
    reducers: {
        addOne: userAdapter.addOne,
        addMany: userAdapter.addMany,
        setAll: userAdapter.setAll,
    },
});

export const usersSelector = userAdapter.getSelectors<UsersRootState>((state) => state.entities.users);
export type UsersSelectorType = typeof usersSelector;

export const userActions = userSlice.actions;
export type UserActionsType = typeof userActions;
